import React, { useState, useRef, useEffect } from 'react';
import { getGlobalDevolution } from '../../services/cashFlow/cashFlow'
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { cedimi } from '../../constant/globalConstantsTypeClients';
import moment from 'moment';
import * as XLSX from 'xlsx';



export const useReportDevolutions = () => {

  // ? REPORT
  const [chartDataDevolution, setChartDataDevolution] = useState({});
  const [chartOptionsDevolution, setChartOptionsDevolution] = useState({});
  const [globalDevolutionFilter, setGlobalDevolutionFilter] = useState(null);
  const [devolutionPatient, setDevolutionPatient] = useState([])
  const chartDevolutionRef = useRef(null);
  const [createSweet] = useSweetAlert();
  const [loadingCancell, setLoadingCancell] = useState(false);
  let _cliente = localStorage.getItem('url_helen');





  const [filters, setFilters] = useState({
    dateStart: moment().format("YYYY-MM") + "-01",
    dateEnd: moment().endOf('month').format("YYYY-MM-DD"),
  });

  useEffect(() => {
    GetReportDevolutions()
  }, [])


  const GetReportDevolutions = async (alterDateStart = null, alterDateEnd = null) => {
    try {
      setLoadingCancell(true);

      let detailDevolution = await getGlobalDevolution(
        alterDateStart ?? filters.dateStart,
        alterDateEnd ?? filters.dateEnd
      );
      console.log("🚀 ~ useReportDevolutions ~ detailDevolution:", detailDevolution)

      if (detailDevolution.code === 200) {

        let cancell = detailDevolution.data;

        let _sum = 0;
        if (cancell && cancell.length > 0) {
          _sum = cancell.reduce((acc, item) => acc + (item.amount || 0), 0);
        }

        let formatted = _sum.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        setDevolutionPatient(cancell);

        let grouped = {};
        cancell.forEach(item => {
          let id = item.id_user_responsible;
          let name = item.user_autorized || 'Sin nombre';

          if (!grouped[id]) {
            grouped[id] = {
              name,
              total: 0,
              count: 0
            };
          }

          grouped[id].total += item.amount || 0;
          grouped[id].count += 1;
        });

        let groupedData = Object.values(grouped);

        let colorSet1 = [
          '#42A5F5', '#66BB6A', '#FFA726', '#AB47BC',
          '#EC407A', '#FF7043', '#26C6DA', '#D4E157',
          '#8D6E63', '#26A69A', '#7E57C2', '#FFCA28'
        ];

        let colorSet2 = [
          '#90CAF9', '#A5D6A7', '#FFCC80', '#CE93D8',
          '#F48FB1', '#FFAB91', '#80DEEA', '#DCE775',
          '#BCAAA4', '#80CBC4', '#B39DDB', '#FFE082'
        ];

        let userCount = groupedData.length;

        let chartData = {
          labels: groupedData.map(item => item.name),
          datasets: [
            {
              label: 'Total devuelto ($)',
              data: groupedData.map(item => item.total),
              backgroundColor: colorSet1.slice(0, userCount)
            },
            {
              label: 'Veces aplicadas',
              data: groupedData.map(item => item.count),
              backgroundColor: colorSet2.slice(0, userCount)
            }
          ]
        };

        let chartOptions = {
          responsive: true,
          plugins: {
            legend: {
              position: 'top'
            },
            tooltip: {
              callbacks: {
                label: function (ctx) {
                  const label = ctx.dataset.label;
                  const value = ctx.raw;
                  return `${label}: ${label === 'Total devuelto ($)' ? '$' + value.toFixed(2) : value}`;
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Cantidad'
              }
            },
            x: {
              ticks: {
                display: false
              },
              grid: {
                display: false
              },
              title: {
                display: false
              }
            }
          }
        };
        setChartDataDevolution(chartData);
        setChartOptionsDevolution(chartOptions);
      } else {
        // setDevolutionPatient([]);
        setChartDataDevolution({});
        setChartOptionsDevolution({});
      }

    }
    catch (error) {
      createSweet("error", "error", "Opss..", "Error al obtener el reporte de credito");
    }
    finally {
      setLoadingCancell(false);
    }



  };


  function exportToExcelDevolution(nimDataExcel) {
    let _Report = [];
    let _array = devolutionPatient;

    _array.forEach((_find, key) => {

      let reportObject = {
        "Nim": _find?.nim ?? "---",
        "Fecha de ingreso": _find?.date_create ?? "---",
        "Sucursal": _find?.branch ?? "---",
        "Paciente": _find?.name_patient ?? "---",
        "Tipo de ingreso": _find?.type ?? "---",
        "Monto": _find?.amount ?? "---",
        "Motivo de devolución": _find?.reazon_cancellation ?? "---",
        "Responsable": _find?.user_autorized ?? "---",
        "Fecha de devolución": _find?.date_cancellation ?? "---",
      };
      _Report.push(reportObject);
    });
    console.log("🚀 ~ exportToExcelDevolution ~ _Report:", _Report)


    const worksheet = XLSX.utils.json_to_sheet(_Report);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = 'Reporte Devoluciones.xlsx';

    if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
    } else {
      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  const handleReport = () => {
    GetReportDevolutions(filters.dateStart, filters.dateEnd);
  };

  const [viewCard, setViewCard] = useState(true)

  const handleViewCard = () => {
    setViewCard(!viewCard)
  }

  const handleCloseCard = () => {
    setViewCard(false)
  }








  return {
    setFilters, filters, loadingCancell,
    chartDataDevolution, chartOptionsDevolution, globalDevolutionFilter,
    chartDevolutionRef, handleReport, exportToExcelDevolution,
    setGlobalDevolutionFilter, devolutionPatient,
    handleViewCard, handleCloseCard, viewCard,


  }
}

